import React from "react";

const DeleteModal = ({
  heading,
  value,
  handleDelete = () => {},
  confirmText = "Delete",
  cancelText = "Cancel",
  modalId = "delete_modal",
}) => {
  return (
    <div
      className="modal fade"
      id={modalId}
      tabIndex={-1}
      aria-labelledby="ct_maintenance_delete_postLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog  modal-dialog-centered">
        <div className="modal-content ct_border_radius_20">
          <div className="modal-body">
            <div className="ct_delete_post_modal p-4">
              <figure>
                <figcaption>
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h4 className="ct_fs_24 ct_fw_600 ct_blue_text mb-2">
                        {heading}
                      </h4>
                      <p className="mb-0 ct_text_para ct_fs_16">{value}</p>
                    </div>
                    <div data-bs-dismiss="modal" className="ct_pointer">
                      <i className="fa-solid fa-xmark"></i>
                    </div>
                  </div>
                </figcaption>
              </figure>
              <div className="d-flex justify-content-end border-0 gap-2 ct_modal_footer ct_mt_30">
                <a
                  data-bs-dismiss="modal"
                  onClick={handleDelete}
                  className="ct_border_radius_5 ct_h_40 ct_orange_btn text-center ct_pointer px-4"
                >
                  {confirmText}
                </a>
                <a
                  data-bs-dismiss="modal"
                  className="ct_border_radius_5 ct_h_40 ct_orange_transparent_btn text-center ct_pointer px-4"
                >
                  {cancelText}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
